var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOauth2)?_c('Oauth2'):(_vm.isSSO)?_c('SSOLogin'):(_vm.isRegister)?_c('RegisterLogin'):(_vm.$store.getters.isPrivate)?_c('PrivateLogin'):_c('BaseLogin')}
var staticRenderFns = []

export { render, staticRenderFns }